import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import configureStore, { history } from "./store";
import App from "./containers/App";
import { SnackbarProvider } from "notistack";

export const store = configureStore();

const MainApp = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          maxSnack={3}
        >
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </SnackbarProvider>
      </ConnectedRouter>
    </Provider>
  );
};

export default MainApp;
